export default __webpack_public_path__ + "static/media/logo.ebf73074.jpg";